import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-due-date',
  templateUrl: './due-date.component.html',
  styleUrls: ['./due-date.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DueDateComponent {
  @Input() diffInDays: number;
  @Input() dueLabel: string;
}
